import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 28689 30582"
    {...props}
  >
    <defs>
      <style>
        {/* {".str0{stroke:#1c1b17;stroke-width:337.223}.fil0{fill:#1c1b17}"} */}
      </style>
    </defs>
    <g id="Layer_x0020_1">
      <path
        d="M3155 14969c-1093 9344 8922 13779 14519 10417 3828-2299 3815-4894 5398-8121 1250-2549 3590-1791 3808-373 235 1522-861 3315-3079 2617l-377-67c-12-32-63-1-91 9-224 1351 256 1921 1539 1977 3691 162 4731-4532 2436-6273-1930-1465-4202-124-5084 1118-1990 2802-2539 6780-6926 7888-1993 504-4521 388-6277-362-5100-2177-5161-7260-5866-8830z"
        className="fil0 "
      />
      <path
        d="M21873 23610c828 310 2497 808 2805 1816 1018 3338-12991 4935-20064 2635-960-312-2296-840-2908-1406-1619-1498-486-1974-106-2755-1860 789-1805 2122-423 3291 2837 2399 9180 3222 12888 3223 2931 1 11383-274 12267-3423 811-2888-2788-3500-5033-3638l574 257zM4487 11866c-1887 616-1573 2664 3191 3654 3683 764 12918 911 15113-1854 1637-2064-3293-3257-5114-3186 4866 975 4142 4020-3176 4507-1691 112-12324 216-10014-3121z"
        className="fil0 "
      />
      <path
        d="m10325 12651 151-192c19-28 108-156 131-193 1838-2913 2388-2053 5595-4622 3136-2510 2405-6481 677-7323 714 2359-1803 5425-2867 6284l-2361 2381c-705 941-1319 2133-1326 3665zM7490 10457c525-623 474-875 1283-1619l2802-2095c1484-1173 2518-3708 261-4893 426 825 98 1763-273 2438-551 1003-1499 1751-2355 2674-854 918-1610 1424-1718 3495zM14602 12060l470-516c451-503 1099-805 1714-1153 1561-882 5063-2080 4437-4815-127-556-424-938-855-1233 251 1725-1331 3098-2545 4067-1253 998-2903 1743-3221 3650z"
        className="fil0 "
      />
    </g>
  </svg>
)
export default SvgComponent
